<template>
  <div class="recommend-info-box" @click="toArtInfo(item.informationId, item.type, item.linkUrl)">
    <div class="info-left">
      <van-image style="pointer-events:none;" radius="12" class="img" v-if="!useDefault" fit="cover" :src="mainImg+'?x-oss-process=image/resize,l_682'" @error="imgOnError" />
      <img style="pointer-events:none;" class="img" v-if="useDefault" :src="require('@/assets/info_default.png')" />
    </div>
    <div class="info-right">
      <span class="info-title">{{ item.title }}</span>
      <span class="info-desc">{{ item.description }}</span>
      <span class="info-source">来源：{{ item.source }}</span>
    </div>
  </div>
</template>

<script>
// import { ImagePreview } from 'vant'
export default {
  name: 'InfoS',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      useDefault: false
    }
  },
  async created () {
    this.mainImg = this.item.cover
  },
  computed: {
  },
  methods: {
    toArtInfo (id, type, linkUrl) {
      if (type === 'INSIDE') {
        const url = `http://room.yslt.art/SharePageTest/?id=${id}#/artinfo`
        window.location.href = url
      } else if (type === 'EXTERNAL') {
        // const url = `http://room.yslt.art/SharePageTest/?url=${linkUrl}&title=${this.item.title}#/webpage`
        window.location.href = linkUrl
      }
    },
    imgOnError () {
      this.useDefault = true
    }
  }
}
</script>

<style lang="scss" scoped>
.recommend-info-box:first-child {
    margin-top: 0;
}
.recommend-info-box {
    margin-top: 12px;
  display: flex;
    padding: 0 21px 21px 21px;
    border-bottom: 1px solid #f6f6f6;
  .info-left {
    height: 98px;
    width: 98px;
    background-color: aliceblue;
      border-radius: 12px;
      margin-right: 10px;
    .img {
      height: 98px;
      width: 98px;
      border-radius: 12px;
    }
    img {
      border-radius: 12px;
    }
  }

  .info-right {
    flex: 1;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
    .info-title {
      /* 控制显示 */
      -webkit-line-clamp: 1 !important;
      /* 控制显示行数 */
      line-clamp: 1 !important;
      font-weight: bold;
      color: #333;
      font-size: 16px;
    }
    .info-source {
      /* 控制显示 */
      -webkit-line-clamp: 1;
      /* 控制显示行数 */
      line-clamp: 1;
      color: #666;
      font-size: 12px;
      margin-top: 6px;
    }
    .info-desc {
      /* 控制显示 */
      -webkit-line-clamp: 2 !important;
      /* 控制显示行数 */
      line-clamp: 2 !important;
      margin-top: 14px;
      color: #333;
      font-size: 14px;
    }
  }

}
</style>
